var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivalReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.84766,
    cy: 8.50635,
    r: 8,
    fill: "#003563"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84766 13.0063C7.59141 13.0063 6.52734 12.5704 5.65547 11.6985C4.78359 10.8267 4.34766 9.7626 4.34766 8.50635C4.34766 7.2501 4.78359 6.18604 5.65547 5.31416C6.52734 4.44229 7.59141 4.00635 8.84766 4.00635C9.49453 4.00635 10.1133 4.13994 10.7039 4.40713C11.2945 4.67432 11.8008 5.05635 12.2227 5.55322V4.00635H13.3477V7.94385H9.41016V6.81885H11.7727C11.4727 6.29385 11.0625 5.88135 10.5422 5.58135C10.0219 5.28135 9.45703 5.13135 8.84766 5.13135C7.91016 5.13135 7.11328 5.45947 6.45703 6.11572C5.80078 6.77197 5.47266 7.56885 5.47266 8.50635C5.47266 9.44385 5.80078 10.2407 6.45703 10.897C7.11328 11.5532 7.91016 11.8813 8.84766 11.8813C9.56953 11.8813 10.2211 11.6751 10.8023 11.2626C11.3836 10.8501 11.7914 10.3063 12.0258 9.63135H13.207C12.9445 10.6251 12.4102 11.436 11.6039 12.0642C10.7977 12.6923 9.87891 13.0063 8.84766 13.0063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalReturn);
export default __webpack_public_path__ + "static/media/arrival-return.65065072ec4d0fadba8159c5ce34a872.svg";
export { ForwardRef as ReactComponent };